import React, { useRef, useState, useEffect, useContext } from "react";
import PageNav from "../components/PageNav";
import Featured from "../components/Featured";
import classNames from "classnames";
import CheckResultImg from "../images/checkResultImg.png";
// import checkResultBannerLogo from '../svg/check-result-banner-logo.svg'
import useOnClick from "../components/common/ClosePopUp";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import EmptyBoxSvg from "../svg/EmptyBoxSvg";
import { animated, useSpring } from "react-spring";
import loadingSpin from "../images/loadingSpin.gif";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from "../components/common/Card";

const VirtualClassroom = () => {
  const authContext = useContext(AuthContext);
  // const studentId = authContext.studentInfo[0].studentId;
  const id = JSON.parse(localStorage.getItem("studentInfo"));
  const studentId = id[0].studentId;

  const [displayDropdown, setDisplayDropdown] = useState(false);
  const [displayClassDropdown, setDisplayClassDropdown] = useState(false);
  const [clickedReport, setClickedReport] = useState("Show All Reports");
  const [clickedClassDropdown, setClickedClassDropdown] = useState("All terms");
  const [selectedResult, setResultType] = useState("all");
  const [fetchdResults, setFetchedResults] = useState([]);
  const [showAll, setShowAll] = useState(true);
  const [halfTerm, setHalfTerm] = useState(false);
  const [finalTerm, setFinalTerm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(false);

  const sessionReport = [
    "Show All Reports",
    "Half Term Reports",
    "Final Reports",
  ];
  const schoolDomain = localStorage.getItem("schoolDomain");
  const deploymentIdx = JSON.parse(localStorage.getItem("subSchoolData")).idx;

  // const schoolDomain = window.location.host;

  const getStudentResults = async (resulttype) => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${authContext.baseUrl}/student/results/${schoolDomain}/${studentId}/${deploymentIdx}?resulttype=${resulttype}`
      );
      // console.log(data.data);
      if (data.status) {
        setFetchedResults(data.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setFetchError(true);
      // console.log(error)
    }
  };

  useEffect(() => {
    getStudentResults("all");
    return () => {};
  }, []);

  const showDropdown = classNames({
    hidden: !displayDropdown,
    "bg-white absolute mt-10 text-gray-100 leading-4 text-xs border rounded-md border-gray-500": true,
  });

  const ShowClassDropdown = classNames({
    hidden: !displayClassDropdown,
    "bg-white w-full absolute mt-10 text-gray-100 leading-4 text-xs border rounded-md border-gray-500": true,
  });

  const displaySessions = (session) => {
    // alert(session);
    setDisplayDropdown(!displayDropdown);
    setClickedReport(session);
    setDisplayDropdown(!displayDropdown);
    // const sessionReport = ["Show All Reports", "Half Term Reports", "Final Reports"];

    // if (session === "Show All Reports") {
    //     setResultType("all");
    //     // getStudentResults("all")

    // }
    if (session === "Half Term Reports") {
      getStudentResults("half");
    } else if (session === "Final Reports") {
      getStudentResults("full");
    }
    // switch (session) {
    //     case 'Show All Reports': setShowAll(!showAll); setHalfTerm(false); setFinalTerm(false); break;
    //     case 'Half Term Reports': setHalfTerm(true); setShowAll(false); setFinalTerm(false); break;
    //     case 'Final Reports': setFinalTerm(true); setHalfTerm(false); setShowAll(false); break;
    //     default: setShowAll(!showAll);
    // }
  };

  const displayTerms = (term) => {
    setClickedClassDropdown(term);
    setDisplayClassDropdown(!displayClassDropdown);
    switch (term) {
      case "JSS1":
        setShowAll(!showAll);
        setHalfTerm(false);
        setFinalTerm(false);
        break;
      case "JSS2":
        setHalfTerm(true);
        setShowAll(false);
        setFinalTerm(false);
        break;
      case "JSS3":
        setFinalTerm(true);
        setHalfTerm(false);
        setShowAll(false);
        break;
      default:
        setShowAll(!showAll);
    }
  };

  const Heading = () => (
    <>
      <span className='text-2xl leading-7 font-semibold text-white mt-1'>
        {" "}
        Results{" "}
      </span>
    </>
  );

  const pageSvg = () => (
    <>
      <img
        src={CheckResultImg}
        alt='check result'
        className='w-1/2 object-cover'
      />
    </>
  );

  const ref = useRef();

  const classDdRef = useRef();

  useOnClick(ref, () => setDisplayDropdown(false));

  useOnClick(classDdRef, () => setDisplayClassDropdown(false));

  const showNoNotes = classNames({
    "grid place-content-center text-center w-full mt-16": true,
    // 'hidden': fetchdResults.length > 0
  });

  const AllReports = () => (
    <>
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 col-gap-6'>
        {fetchdResults &&
          fetchdResults.length > 0 &&
          fetchdResults.map((item) => {
            if (item.resulttype != null) {
              const termColor = classNames({
                "w-3 h-3 rounded-full": true,
                "bg-green-100":
                  item.term === "FIRST TERM" || item.term === "SECOND TERM",
                "bg-red-100": item.term === "THIRD TERM",
              });
              return (
                <div className=' bg-white p-4 mb-6 text-gray-100 mr-4 newNotesShadow'>
                  <div className='flex justify-end items-center mb-4'>
                    <span className={termColor} />
                  </div>
                  <div className='flex justify-start items-center mb-4'>
                    <span className='text-gray-300 text-xs'>
                      {" "}
                      {item.class}{" "}
                    </span>
                  </div>
                  <div className='block'>
                    <div className='flex justify-start mx-auto font-semibold text-base mb-4'>
                      {item.term}
                    </div>
                    <div className='flex justify-start text-xs text-gray-100 leading-3 mb-4'>
                      <div className='studentClass'> {item.studentClass}</div>
                    </div>
                    <div className='flex justify-start text-xs text-gray-500 leading-3 mb-4'>
                      <span className='flex justify-start'> {item.year} </span>
                    </div>

                    <div className='bg-blue-900 block mx-auto'>
                      <a
                        href={item.resultUrl}
                        target='_blank'
                        className='flex justify-center text-blue-100 text-xs font-semibold leading-3 p-2 uppercase cursor-pointer'>
                        {item.resulttype.toLowerCase().includes("semester") ||
                        item.resulttype.toLowerCase().includes("term")
                          ? `${item.resulttype} Report`
                          : `${item.resulttype} Term Report`}
                      </a>
                    </div>
                  </div>
                </div>
              );
            }
          })}
      </div>
      <>
        {loading && (
          <div className='flex justify-center w-full my-24'>
            <img src={loadingSpin} alt='loading...' />
          </div>
        )}
        {fetchdResults.length === 0 && !loading && (
          <div className={showNoNotes}>
            <div className='p-4 flex flex-col justify-center items-center w-56'>
              <span className='font-bold flex justify-center pb-4'>
                {" "}
                Empty Result{" "}
              </span>
              <span className='flex justify-center pb-4 -ml-2'>
                <EmptyBoxSvg />
              </span>
              <span className='text-gray-300 text-xs leading-tight flex justify-center pl-2'>
                {" "}
                Your child's result will show here.{" "}
              </span>
            </div>
          </div>
        )}
      </>
    </>
  );

  const transitionStyles = useSpring({
    to: [{ opacity: 1, transform: "translateX(0)" }],
    from: { opacity: 0, transform: "translateX(80px)" },
    config: { duration: 1000 },
  });

  return (
    <div className='px-4 sm:flex sm:px-0'>
      <animated.div style={transitionStyles} className='w-full sm:w-2/3'>
        <PageNav Heading={Heading} PageSvg={pageSvg} />
        <div className='py-6 px-0 w-full'>
          <div className='flex '>
            <span className='font-bold flex flex-no-wrap mt-2 text-sm sm:text-base'>
              {" "}
              Show{" "}
            </span>
            <div ref={ref} className='flex flex-col relative ml-2 sm:ml-4'>
              <span
                onClick={() => setDisplayDropdown(!displayDropdown)}
                className='w-28 sm:w-32 flex justify-between items-center p-2 bg-white rounded-md border border-gray-600 h-10 cursor-pointer mb-2'>
                <span className='leading-4 text-xs text-gray-100 mr-3'>
                  {" "}
                  {clickedReport}{" "}
                </span>
                <span className='pt-1'>
                  <svg
                    width='7'
                    height='6'
                    viewBox='0 0 7 6'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M3.76959 5.78571C3.60464 6.07143 3.19224 6.07143 3.02729 5.78571L0.0580571 0.642857C-0.1069 0.357143 0.0992962 -2.8842e-08 0.429211 0L6.36767 5.19157e-07C6.69759 5.47999e-07 6.90378 0.357143 6.73882 0.642858L3.76959 5.78571Z'
                      fill='#000114'
                    />
                  </svg>
                </span>
              </span>
              <ul className={showDropdown}>
                {sessionReport.map((session) => (
                  <li
                    onClick={() => displaySessions(session)}
                    className='p-2 hover:text-blue-200 text-xs rounded border-md border-gray-200 cursor-pointer transition ease-in-out duration-100'>
                    {session}
                  </li>
                ))}
              </ul>
            </div>
            {/* <div ref={classDdRef} className="flex flex-col relative ml-3">
                                <span onClick={()=> setDisplayClassDropdown(!displayClassDropdown)} className="w-28 sm:w-32 flex justify-between items-center p-2 bg-white rounded-md border border-gray-600 h-10 cursor-pointer mb-2">
                                    <span className="leading-4 text-xs text-gray-100 mr-3"> {clickedClassDropdown} </span>
                                    <span className="pt-1">
                                        <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.76959 5.78571C3.60464 6.07143 3.19224 6.07143 3.02729 5.78571L0.0580571 0.642857C-0.1069 0.357143 0.0992962 -2.8842e-08 0.429211 0L6.36767 5.19157e-07C6.69759 5.47999e-07 6.90378 0.357143 6.73882 0.642858L3.76959 5.78571Z" fill="#000114"/>
                                        </svg>
                                    </span>
                                </span>
                                <ul className={ShowClassDropdown}>
                                    { classes.map(term => (
                                        <li onClick={() => displayTerms(term)} className="p-2 hover:text-blue-200 text-xs rounded border-md border-gray-200 cursor-pointer transition ease-in-out duration-100"> 
                                            {term} 
                                        </li>
                                    ))}
                                </ul>
                            </div> */}
          </div>
          {showAll && (
            <div className='mt-4'>
              <div className='mt-4'>
                <AllReports />
              </div>
            </div>
          )}
          {fetchError && (
            <div className='mt-4 mx-auto w-64'>
              <Card>
                <div className='block text-center w-full p-6'>
                  <FontAwesomeIcon icon={faBan} className='text-red-100' />
                  <div className='text-xs sm:text-sm text-red-300 font-semibold'>
                    Oops! Something Went Wrong
                  </div>
                  <div className='text-center text-blue-200 cursor-pointer mt-4'>
                    <span
                      className='hover:text-blue-300 hover:underline'
                      onClick={window.location.reload()}>
                      Try refresh
                    </span>
                  </div>
                </div>
              </Card>
            </div>
          )}
        </div>
      </animated.div>
      <div className='w-full sm:w-1/3 sm:mx-4 mt-6'>
        <Featured />
      </div>
    </div>
  );
};

export default VirtualClassroom;
